import { clsx, styleAndCapture } from 'external/material'

import useTextMeasurer from "hooks/text-measurer"

const StyledMultiline = styleAndCapture('div', ['width', 'fontSize', 'fontFamily'])(multilineTextStyles)

export default function MultilineText (props) {
    const {className, text, width, maxLines = 2, fontSize, fontFamily} = props
    const measureText = useTextMeasurer(props)
    const words = text.split(' ')
    const {lines} = words.reduce(({lines, complete}, word) => {
        if (lines.length <= maxLines && complete) {
            const lastLine = lines[lines.length - 1]
            const line = `${lastLine} ${word}`
            const lastLineWidth = measureText(line)
            if (lastLineWidth > width) {
                if (lines.length == maxLines) {
                    lines[lines.length - 1] = line
                    return {lines, complete: false}
                } else {
                    lines.push(word)
                    return {lines, complete}
                }
            } else {
                lines[lines.length - 1] = line
            }
        }
        return {lines, complete}
    }, {lines: [''], complete: true})
    return (
        <StyledMultiline
            className={clsx('lines', className)}
            title={text}
            width={width}
            fontSize={fontSize}
            fontFamily={fontFamily}
        >
            {lines.map((line, i) => (<div key={i} className='line'>{line}</div>))}
        </StyledMultiline>)
}

function multilineTextStyles({width, fontSize, fontFamily}) {
   return {
       fontSize,
       fontFamily,
       display: 'flex',
       flexDirection: 'column',
       width,
       "& > .line:last-of-type": {
           overflow: 'hidden',
           whiteSpace: 'nowrap',
           textOverflow: 'ellipsis'
       }
   } 
}
